import en_account from "views/AccountStatement/en.js";
import es_account from "views/AccountStatement/es.js";

import en_delivery_panel from "apps/DeliveryPanel/lang/en.js";
import es_delivery_panel from "apps/DeliveryPanel/lang/es.js";

import es_invoice from "views/Invoice/es.js";
import en_invoice from "views/Invoice/en.js";

import es_guest from "views/AppWebCheckIn/es.js";
import en_guest from "views/AppWebCheckIn/en.js";

import es_folio from "views/HotelFolio/es.js";
import en_folio from "views/HotelFolio/en.js";
import zh_folio from "views/HotelFolio/zh.js";
import fr_folio from "views/HotelFolio/fr.js";
import pt_folio from "views/HotelFolio/pt.js";

import en_staff_schedule from "apps/StaffShiftSchedule/en.js";
import es_staff_schedule from "apps/StaffShiftSchedule/es.js";

import es_staff_assistance from "apps/StaffAssistance/es.js";
import en_staff_assistance from "apps/StaffAssistance/en.js";

import es_appointment_scheduling from "apps/AppointmentScheduling/es.js";
import en_appointment_scheduling from "apps/AppointmentScheduling/en.js";

import en_party from "apps/Partyv2/en.js";
import es_party from "apps/Partyv2/es.js";

import en_account_statement from "apps/AccountStatement/lang/en.js";
import es_account_statement from "apps/AccountStatement/lang/es.js";

import en_hotel_frontdesk from "apps/HotelFrontdesk/en.js";
import es_hotel_frontdesk from "apps/HotelFrontdesk/es.js";

import en_hotel_housekeeping from "apps/Housekeeping/en.js";
import es_hotel_housekeeping from "apps/Housekeeping/es.js";

import en_supplies from "apps/StaffSupply/lang/en.js";
import es_supplies from "apps/StaffSupply/lang/es.js";

import es_crm from "apps/CRMSales/lang/es.js";
import en_crm from "apps/CRMSales/lang/en.js";

import en_sale_validation from "apps/SaleValidation/lang/en.js";
import es_sale_validation from "apps/SaleValidation/lang/es.js";

import en_folio2 from "apps/HotelFolio/lang/en.js";
import es_folio2 from "apps/HotelFolio/lang/es.js";

import en_web_booking from "ext-apps/WebBookingHotel/lang/en.js";
import es_web_booking from "ext-apps/WebBookingHotel/lang/es.js";
import zh_web_booking from "ext-apps/WebBookingHotel/lang/zh.js";
import fr_web_booking from "ext-apps/WebBookingHotel/lang/fr.js";
import pt_web_booking from "ext-apps/WebBookingHotel/lang/pt.js";

import en_webcheckin from "ext-apps/WebCheckIn/lang/en.js";
import es_webcheckin from "ext-apps/WebCheckIn/lang/es.js";
import zh_webcheckin from "ext-apps/WebCheckIn/lang/zh.js";
import fr_webcheckin from "ext-apps/WebCheckIn/lang/fr.js";
import pt_webcheckin from "ext-apps/WebCheckIn/lang/pt.js";

import en_hotel_calendar from "apps/HotelCalendar/lang/en.js";
import es_hotel_calendar from "apps/HotelCalendar/lang/es.js";

import es_hotel_tra from "ext-apps/WebTra/lang/es.js";
import en_hotel_tra from "ext-apps/WebTra/lang/en.js";
import fr_hotel_tra from "ext-apps/WebTra/lang/fr.js";
import pt_hotel_tra from "ext-apps/WebTra/lang/pt.js";
import zh_hotel_tra from "ext-apps/WebTra/lang/zh.js";

import es_company_integration from "apps/CompanyIntegration/lang/es.js";
import en_company_integration from "apps/CompanyIntegration/lang/en.js";
import es_production from "apps/Production/lang/es.js";
import en_production from "apps/Production/lang/en.js";

import en_staff_meal from "apps/MealStaff/lang/en.js";
import es_staff_meal from "apps/MealStaff/lang/es.js";

import en_sale_order_tabs from "apps/SaleOrderTabs/lang/en.js";
import es_sale_order_tabs from "apps/SaleOrderTabs/lang/es.js";

import es_services_hotel from "apps/ServicesHotel/lang/es.js";
import en_services_hotel from "apps/ServicesHotel/lang/en.js";

import en_vps from "apps/Vps/lang/en.js";
import es_vps from "apps/Vps/lang/es.js";

import en_hotel_rack from "apps/HotelRack/lang/en.js";
import es_hotel_rack from "apps/HotelRack/lang/es.js";

import en_booking from "apps/Booking/lang/en.js";
import es_booking from "apps/Booking/lang/es.js";

import en_hotel_booking from "apps/HotelBooking/lang/en.js";
import es_hotel_booking from "apps/HotelBooking/lang/es.js";

import en_melhous from "apps/Melhous/lang/en.js";
import es_melhous from "apps/Melhous/lang/es.js";

const en = {
  ...en_account,
  ...en_delivery_panel,
  ...en_invoice,
  ...en_guest,
  ...en_folio,
  ...en_folio2,
  ...en_staff_schedule,
  ...en_staff_assistance,
  ...en_appointment_scheduling,
  ...en_party,
  ...en_account_statement,
  ...en_hotel_frontdesk,
  ...en_hotel_housekeeping,
  ...en_supplies,
  ...en_sale_validation,
  ...en_web_booking,
  ...en_webcheckin,
  ...en_hotel_calendar,
  ...en_hotel_tra,
  ...en_company_integration,
  ...en_production,
  ...en_staff_meal,
  ...en_crm,
  ...en_sale_order_tabs,
  ...en_services_hotel,
  ...en_booking,
  ...en_hotel_booking,
  ...en_vps,
  ...en_hotel_rack,
  ...en_melhous,
};

const es = {
  ...es_account,
  ...es_delivery_panel,
  ...es_invoice,
  ...es_guest,
  ...es_folio,
  ...es_folio2,
  ...es_staff_schedule,
  ...es_staff_assistance,
  ...es_appointment_scheduling,
  ...es_party,
  ...es_account_statement,
  ...es_hotel_frontdesk,
  ...es_hotel_housekeeping,
  ...es_supplies,
  ...es_sale_validation,
  ...es_web_booking,
  ...es_webcheckin,
  ...es_hotel_calendar,
  ...es_hotel_tra,
  ...es_company_integration,
  ...es_production,
  ...es_staff_meal,
  ...es_crm,
  ...es_sale_order_tabs,
  ...es_services_hotel,
  ...es_booking,
  ...es_hotel_booking,
  ...es_vps,
  ...es_hotel_rack,
  ...es_melhous,
};

const fr = {
  ...fr_webcheckin,
  ...fr_hotel_tra,
  ...fr_web_booking,
  ...fr_folio,
};

const pt = {
  ...pt_webcheckin,
  ...pt_hotel_tra,
  ...pt_web_booking,
  ...pt_folio,
};

const zh = {
  ...zh_webcheckin,
  ...zh_hotel_tra,
  ...zh_web_booking,
  ...zh_folio,
};

export { en, es, fr, pt, zh };
